export default `
# BiznisNET – expand abroad

Do you want to know how the embassies in Slovakia, chambers of commerce and other institutions can help Slovak entrepreneurs with expanding abroad? Join our event biznisNET, get new information and new contacts.

Are you planning on expanding your business abroad or thinking about establishing a business with this vision?

The representatives from embassies, chambers of commerce, and other institutions from Slovakia, and abroad will be presenting the opportunities for your future successful business.

THE EVENT IS FREE OF CHARGE, AND THERE IS NO NEED TO REGISTER.

What can you expect?

In one place, in panel discussions or individually you will be able to meet and talk to the representatives of France, Belgium, Austria, Georgia, Mexico, Indonesia, Ukraine, Belarus, USA, United Kingdom, Netherlands. This networking event could open new opportunities for you in your future business abroad.
`



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/about/text.js